
/**
 * New directive for showing type ahead when direction search returns address suggestions
 */
angular.module('cvsApp').directive('typeaheadFocusDirection', function ($timeout,$rootScope) {
    return {
    require: 'ngModel',
    link: function (scope, element, attr, ngModel) {
      element.bind('click', function () {
         
       if($rootScope.typeaheadDirectionsListValue){
           var viewValue = $rootScope.typeaheadDirectionsListValue

           if (ngModel.$viewValue == ' ') {
              ngModel.$setViewValue(null);
            }

           ngModel.$setViewValue(' ');
           if(typeof $rootScope.destinationName == 'object'){
                ngModel.$setViewValue($rootScope.destinationName.Name || ' ');
            } else {
                ngModel.$setViewValue($rootScope.destinationName || ' ');
           }

            }
          });

      scope.emptyOrMatch = function (actual, expected) {
        if (expected == ' ') {
          return true;
        }
        var str = "";
        if(typeof actual === "string"){
         str = actual.replace(/[,.]/g , '');
        }
        return str.indexOf(expected) > -1;
      };
    }
  };
});
